import { Components, Theme } from "@mui/material/styles";
import Action from "../colors/Action";
import Primary from "../colors/Primary";

declare module "@mui/material/Button" {
    interface ButtonPropsVariantOverrides {
        outlinedPrimaryDark: true;
    }
}

export const MuiButtonComponent: Components<Theme>["MuiButton"] = {
    styleOverrides: {
        root: {
            textTransform: "none",
            minWidth: "auto",
        },
        containedPrimary: {
            //TODO: Update this as per the figma colour
        },
        containedSecondary: {
            //TODO: Update this as per the figma colour
        },
        outlinedPrimary: {
            //TODO: Update this as per the figma colour
        },
        textPrimary: {
            color: Primary.main,
            "&:hover": {
                backgroundColor: Action.background[90],
            },
        },
        textSecondary: {
            color: Action[50],
            "&:hover": {
                backgroundColor: Action.background[90],
            },
        },
    },
    variants: [
        {
            props: { variant: "outlinedPrimaryDark" },
            style: {
                border: "1px solid",
                color: Primary.white,
                borderColor: Primary.white,
                backgroundColor: "transparent",
                borderRadius: 4,
                "&:hover": {
                    backgroundColor: "transparent",
                    borderColor: Primary.white,
                    border: "1px solid",
                },
            },
        },
    ],
};
